import React, { useContext, useState, useEffect } from 'react';
import Footer from '../Charts/Footer/Footer';
import Navigation from '../Navigation/Navigation'
import { useLocation } from 'react-router-dom';
import { baseFileURL } from '../../../Api';
import '../../../i18n';  
import cl from './Layout.module.css'  
import { AppContext } from '../../../providers/appProvider';

const Layout = ({ children }) => {
  
  const {appState, app} = useContext(AppContext);
  
  let width100 = '';

  const location = useLocation();

  if(appState.fullwidth === true && location.pathname.endsWith('/finances')){ 
    width100 = cl.width100; 
  } 


  useEffect(() => {
      if (baseFileURL === 'https://crm.autonomo.kz') { 
          window.location.href = 'https://www.google.com/';
      }
  }, []);

  return (
    <>
      <div className='themeCRM' data-theme="light" data-company={
        baseFileURL === 'https://i-logistics.net'  ||  baseFileURL === 'https://dev.i-logistics.net'  ? (
          'ilogistics'
        ) : baseFileURL === 'https://finance.automoby.ge' ? (
          'automoby'
        ): baseFileURL === 'https://crm.autonomo.kz' ? (
          'autonomo'
        ) : baseFileURL === 'https://crm.aig.com.ge'  ||  baseFileURL === 'https://crmdev.aig.com.ge' ? (
        'aig'
        ) : (
       'automoby'
    )} style={{ height: '100vh' }}>
        <div className={ cl.bgLight } >
          <Navigation />
          <div className={ cl.main }>
            <div className={ cl.inner + ' '+ width100 }>
              { children }
            </div> 
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default Layout

